module.exports = __webpack_public_path__ + "img/9788990713063.92e081ec.jpg";